// Redux
import Subscription from '@/types/subscription';
import { AsyncResult, Action, ApiAction } from '../index';
import api from '../redux-api';

// Types
import { SubscriptionState } from './types/subscription';

// Initial state
const INITIAL_STATE: SubscriptionState = {
  loading: false,
};

// Actions
const GET_PORTAL_SESSION: ApiAction = {
  type: 'connect/subscription/get-chargebee-session',
  endpoint: 'subscription/portal-session',
};

const GET_SUBSCRIPTION_INFOS: ApiAction = {
  type: 'connect/subscription/get-infos',
  endpoint: 'subscription',
};

const GET_CHECKOUT_HOSTED_PAGE: ApiAction = {
  type: 'connect/subscription/get-checkout-page',
  endpoint: 'subscription/checkout',
};

// Reducer
export default function reducer(state: SubscriptionState = INITIAL_STATE, action: Action): SubscriptionState {
  switch (action.type) {
    case GET_SUBSCRIPTION_INFOS.type: {
      return {
        ...state,
        loading: true,
      };
    }
    case `${GET_SUBSCRIPTION_INFOS.type}_ERROR`: {
      return {
        ...state,
        loading: false,
      };
    }
    case `${GET_SUBSCRIPTION_INFOS.type}_SUCCESS`: {
      return {
        ...state,
        subscription: action.data.data,
        loading: false,
      };
    }
    default:
      return state;
  }
}

// Action Creators
export const getChargebeePortalSession = (): AsyncResult<any> => (dispatch, getState) => api.get(GET_PORTAL_SESSION).then((res: { data: any }) => res.data);

export const getSubscriptionInfos = (): AsyncResult<Subscription> => (dispatch, getState) =>
  api.get(GET_SUBSCRIPTION_INFOS).then((res: { data: any }) => res.data);

export const getCheckoutHostedPage =
  (plan: string): AsyncResult<any> =>
  (dispatch, getState) =>
    api.get(GET_CHECKOUT_HOSTED_PAGE, { plan }).then((res: { data: any }) => res.data);
